import * as Localization from 'expo-localization';
import i18n from 'i18n-js';

i18n.translations = {
    en: require('./en.json'),
    "zhs": require('./zhs.json'),
    "zht": require('./zht.json'),
    "jp": require('./jp.json'),
    "th": require('./th.json'),
    "ind": require('./ind.json')
}

export default {
    t: (arr) => i18n.t(arr),
}

i18n.locale = 'zht';
i18n.fallbacks = true;